<template>
    <v-col class="login-input">
        <div 
            v-if="label"
            class="label pl-0 pb-0 pt-0  text small weight-500 text-grey-color"
        >
            {{ label }}
        </div>
        <v-row>
          <v-col cols="12">
            <v-text-field
                :append-icon="append"
                :rules="[rules.required, rules.min]"
                :type="inputStyle && passwordShow ? 'password' : 'text'"
                class="pt-0"
                hide-details
                v-model="model"
                :label="placeholder"
                single-line
                :regular="inputStyle"
                @click:append="passwordShow = !passwordShow"
                @keyup.enter="$emit('on-enter')"
            ></v-text-field>
          </v-col>
          <!-- <v-col 
            class="pt-5 pl-0"
          >
              <v-icon v-if="model !== ''" class="check-icon" medium>check_circle_outline</v-icon>
              <!-- <v-icon class="close-icon material-icons-outlined" medium>cancel_outlined</v-icon> -->
          <!-- </v-col> --> 

        </v-row>
    </v-col>
</template>

<script type="text/javascript">
  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      inputType: {
        type: String,
        default: '',
      },
      inputStyle: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        message: "",
        passwordShow: true,
        password: 'Password',
         rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => (`The email and password you entered don't match`),
        },
      }
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      append() {
        if(this.inputStyle === true && this.passwordShow === false){
          return 'visibility'
        }
        else if (this.inputStyle === false){
          return ''
        }
        else {
          return 'visibility_off'
        }
      }
    }
  }
</script>


<style lang="scss">
    
    .login-input {
      .visibility-off::before, ::after{
			  color: #232e41 !important;
      }
      .visibility::before, ::after{
        color: #232e41 !important;
      }
      .v-text-field > .v-input__control > .v-input__slot {
        color: $grey-login !important;
      }
      .close-icon {
        color: $red-off-icon;
      }
    }

</style>